import { render, staticRenderFns } from "./CartoesPagarme.vue?vue&type=template&id=1f35b1ff&scoped=true"
import script from "./CartoesPagarme.vue?vue&type=script&lang=js"
export * from "./CartoesPagarme.vue?vue&type=script&lang=js"
import style0 from "./CartoesPagarme.vue?vue&type=style&index=0&id=1f35b1ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f35b1ff",
  null
  
)

export default component.exports